import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

import { arraySortByOrder } from '@shared-submodule/utils'
import { Col } from 'react-bootstrap'

const PlayingXI = ({ fantasystyles, probableXI }) => {
  const order = ['bat', 'all', 'wk', 'wkbat', 'bowl']
  const teamOnePlayer = arraySortByOrder({ data: probableXI?.oTeam1?.aPlayers, order, key: 'sPlayingRole' })
  const teamTwoPlayer = arraySortByOrder({ data: probableXI?.oTeam2?.aPlayers, order, key: 'sPlayingRole' })

  return (
    <section className="mt-3">
      <h6 className='d-flex d-md-none'>
        Probable Playing XI
      </h6>
      <div>
        <div className={`${styles.team} common-box mb-3`}>
          <p className="big-text font-bold mb-3">{probableXI?.oTeam1?.oTeam?.sTitle}</p>
          <Col className={styles.playerInfo}>
            <p className={styles.title}>
              Probable XI
            </p>
            <p className={styles.playerList}>
              {teamOnePlayer?.map((player, index) => {
                if (player?._id === probableXI?.oTeam1?.iC) {
                  return `${index ? ', ' : ''}${player?.sShortName}(${'C'})`
                }
                return (index ? ', ' : '') + player?.sShortName
              })}
            </p>
          </Col>
          <Col className={styles.playerInfo}>
            {probableXI?.oTeam1?.aBenchedPlayers && (
              <>
                <p className={`${styles.title} d-none d-md-block`}>
                  Bench
                </p>
                <p className={`${styles.benchList} d-none d-md-block`}>
                  {probableXI?.oTeam1?.aBenchedPlayers?.map((bench, index) => (index ? ', ' : '') + bench?.sShortName)}
                </p>
              </>
            )}
          </Col>
        </div>
        <div className={`${styles.team} common-box mb-3`}>
          <p className="big-text font-bold mb-3">{probableXI?.oTeam2?.oTeam?.sTitle}</p>
          <Col className={styles.playerInfo}>
            <p className={styles.title}>
              Probable XI
            </p>
            <p className={styles.playerList}>
              {teamTwoPlayer?.map((player, index) => {
                if (player?._id === probableXI?.oTeam2?.iC) {
                  return `${index ? ', ' : ''}${player?.sShortName}(${'C'})`
                }
                return (index ? ', ' : '') + player?.sShortName
              })}
            </p>
          </Col>
          <Col className={styles.playerInfo}>
            {probableXI?.oTeam2?.aBenchedPlayers && (
              <>
                <p className={`${styles.title} d-none d-md-block`}>
                  Bench
                </p>
                <p className={`${styles.benchList} d-none d-md-block`}>
                  {probableXI?.oTeam2?.aBenchedPlayers?.map((bench, index) => (index ? ', ' : '') + bench?.sShortName)}
                </p>
              </>
            )}
          </Col>
        </div>
      </div>
    </section>
  )
}

PlayingXI.propTypes = {
  fantasystyles: PropTypes.any,
  probableXI: PropTypes.object
}

export default PlayingXI
